module.exports = __webpack_public_path__ + "7335d4a3894fa69bc03e0478e6d73b79.png";